import { useState } from "react";
import { IconChevronRight } from "@tabler/icons-react";
import SupportHero from "../../components/Support/SupportHero";
import SupportCards from "../../components/Support/SupportCards";
import FaqList from "../../components/Support/FaqList";
import PlatformStatusCard from "../../components/Support/PlatformStatusCard";
import ResponseTimesCard from "../../components/Support/ResponseTimesCard";
import ContactOptionsCard from "../../components/Support/ContactOptionsCard";
import RecentTicketsCard from "../../components/Support/RecentTcketsCard";
import ReportModal from "../../components/Support/ReportModal";
import ContactModal from "../../components/Support/ContactModal";
import BugModal from "../../components/Support/BugModal";
import styles from "../../components/Support/Support.module.css";
import Breadcrumb from "../../components/UI/Breadcrumb/Breadcrumb";
import { Toast as BottomToast } from "../../components/Toast/Toast";

const ClientSupportPage = () => {
  const [heroSearch, setHeroSearch] = useState("");
  const [openFaqId, setOpenFaqId] = useState(null);
  const [openModal, setOpenModal] = useState(null); // null | 'report' | 'contact' | 'bug'
  const [toast, setToast] = useState({ visible: false, message: "" });

  const closeModal = () => setOpenModal(null);
  const toggleFaq = (id) => setOpenFaqId((prev) => (prev === id ? null : id));

  return (
    <div>
      <Breadcrumb
        crumbs={[
          { label: "Dashboard", href: "/client-activity-summary" },
          { label: "Support" },
        ]}
        title="Support Center"
      />

      <SupportHero search={heroSearch} onSearchChange={setHeroSearch} />

      <div className={styles.grid}>
        <div className={styles.main}>
          <SupportCards onOpenModal={setOpenModal} />
          <FaqList
            openId={openFaqId}
            onToggle={toggleFaq}
            onContactClick={() => setOpenModal("contact")}
          />
        </div>

        <aside className={styles.sidebar}>
          <ResponseTimesCard />
          <ContactOptionsCard
            onOpenContactModal={() => setOpenModal("contact")}
          />
        </aside>
      </div>

      <ReportModal
        open={openModal === "report"}
        onClose={closeModal}
        setToast={setToast}
      />
      <ContactModal
        open={openModal === "contact"}
        onClose={closeModal}
        setToast={setToast}
      />
      <BugModal
        open={openModal === "bug"}
        onClose={closeModal}
        setToast={setToast}
      />

      <BottomToast
        visible={toast.visible}
        message={toast.message}
        onDismiss={() => setToast((t) => ({ ...t, visible: false }))}
      />
    </div>
  );
};

export default ClientSupportPage;
